<script>
export default {
    name: 'IconUser',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-user"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 28c8.955 0 16.536 5.886 19.084 14C48.536 50.113 40.955 56 32 56s-16.536-5.886-19.084-14C15.464 33.887 23.045 28 32 28zm0-20a8 8 0 110 16 8 8 0 010-16z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
